import { SAFEA_V3_ENABLED } from '~/constants/_core/safea-v3';

export default {
  async actionUpdateUser({ commit }, userData) {
    if (SAFEA_V3_ENABLED) {
      const formData = new FormData();
      for (const [key, value] of Object.entries(userData)) {
        if (typeof value === 'undefined') {
          continue;
        }
        if (value !== null && typeof value === 'object') {
          throw new Error('Update user - cannot encode object values');
        }
        formData.append(key, value);
      }

      const result = await this.$services._core.userV3().updateUserInfo(formData);
      commit('SET_USER_INFO_V3', result);
      return result;
    }

    const result = await this.$services._core.user().updateUser(userData);
    commit('SET_USER_INFO', result.data);

    return result;
  },

  async actionUpdateUserPhoto({ commit }, file) {
    const formData = new FormData();
    formData.append('photo', file);

    if (SAFEA_V3_ENABLED) {
      const result = await this.$services._core.userV3().updateUserInfo(formData);
      commit('SET_USER_INFO', result);

      return;
    }
    const { data : { photoUrl } } = await this.$services._core.user().updateUserPhoto(formData);
    commit('SET_USER_PHOTO', photoUrl);
  },

  async actionChangeUserPassword({ rootState }, { currentPassword, newPassword }) {
    if (SAFEA_V3_ENABLED) {
      throw new Error('Password change must be done through the identity provider in Safe A v3.');
    }

    const passwordData = {
      currentPassword : currentPassword,
      newPassword     : newPassword
    };

    return await this.$services._core.user().changeUserPassword(passwordData);
  },

  async actionGetUserInfo({ rootState }) {
    return await this.$services._core.user().getUserInfo();
  }
};
